// extracted by mini-css-extract-plugin
export var dataCell = "_n5-2";
export var dataRow = "_n5-0";
export var headerRow = "_n5-1";